/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { Warehouse } from '../../types';
import { UpdateWarehouseAction, UpdateWarehouseActionTypes } from './types';

export interface UpdateWarehouseState {
  warehouse?: Warehouse;
  success: boolean;
  loading: boolean;
  error?: Error;
}

export const initialUpdateWarehouseState: UpdateWarehouseState = {
  warehouse: undefined,
  success: false,
  loading: false,
  error: undefined,
};

export default function updateWarehouseReducer(state = initialUpdateWarehouseState, action: UpdateWarehouseAction) {
  switch (action.type) {
    case UpdateWarehouseActionTypes.UPDATE_WAREHOUSE:
      return update(state, {
        success: { $set: false },
        loading: { $set: true },
        $unset: ['error'],
      });

    case UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_SUCCESS:
      return update(state, {
        success: { $set: true },
        loading: { $set: false },
        warehouse: { $set: action.warehouse },
        $unset: ['error'],
      });

    case UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_ERROR:
      return update(state, {
        success: { $set: false },
        loading: { $set: false },
        error: { $set: action.error },
      });

    case UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_RESET_ERROR:
      return update(state, {
        $unset: ['error'],
      });

    case UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_RESET_STATE:
      return initialUpdateWarehouseState;

    default:
      return state;
  }
}
